import React, { useEffect, useState, useRef } from "react";
// import { makeStyles } from "@mui/styles"; 
import {
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Box,
  ListItemSecondaryAction,
  IconButton
} from "@mui/material";

import DeleteIcon from '@mui/icons-material/Delete';

import WordAddForm from "./WordAddForm";
import DictionaryWordEditor from "../Components/Dictionary/DictionaryWordEditor";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     width: "100%",
//     maxWidth: 360,
//     // backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     marginLeft: theme.spacing(1),
//     marginRight: theme.spacing(1),
//     width: 200,
//   },
// }));

const sortWords = (wordsList) => {
  return wordsList.sort((a, b) => (a.word > b.word ? 1 : ((b.word > a.word) ? -1 : 0)))
}

const makeInitialList = (wordDictionary) => {
  let myList = []
  for (let v of wordDictionary.keys()) {
    if (v) {
      let pointOfSpeech = '';
      let secondary = '';
      try {
        const dictWord = wordDictionary.get(v)
        pointOfSpeech = dictWord.pos
        if (dictWord.comment && dictWord.comment.length > 0)
          secondary += 'Comment: ' + dictWord.comment
        if (dictWord.linkTitle && dictWord.linkTitle.length > 0) {
          if (secondary.length > 0) secondary += ' '
          secondary += 'LinkTitle: ' + dictWord.linkTitle
        }
      } catch (error) {
        console.log(error)
      } 
      
      myList.push({ word: `${wordDictionary.get(v).word} - ${wordDictionary.get(v).translation} (${pointOfSpeech})`, id: wordDictionary.get(v).id, secondary })
    }
  }

  sortWords(myList, (item) => item.word)
  // console.log(myList)
  return myList
}


const DictionaryEditor = ({ mainDictionary, mainDictionarySetter, wordToOpen }) => {
  // const classes = useStyles();

  const [words, setWords] = useState([...(makeInitialList(mainDictionary))]);

  const [selectedWord, setSelectedWord] = useState(null)
  const [editing, setEditing] = useState(false);
  const [visibleItemsCount, setVisibleItemsCount] = useState(200);

  const listRef = useRef(null);

  const handleListItemClick = (word) => {
    setSelectedWord(word);
    setEditing(true);
    // console.log(word)
  };

  useEffect(() => {
    setWords([...makeInitialList(mainDictionary)])
    setVisibleItemsCount(200)
  }, [mainDictionary])

  useEffect(() => {
    if (visibleItemsCount >= words.length) return
    const timeoutId = setTimeout(() => {
      setVisibleItemsCount((prev) => Math.min(prev + 300, words.length))
    }, 0)
    return () => clearTimeout(timeoutId)
  }, [visibleItemsCount, words.length])

  useEffect(() => {
    // console.log('wordToOpen: ', wordToOpen)
    if (!wordToOpen)
      return

    // Scroll to the specified word
      const index = words.findIndex(wordObj => wordObj.id === wordToOpen.dictionaryWordId );
      if (index !== -1) {
        const listItem = listRef.current.children[index];
        listItem.scrollIntoView({ behavior: "instant", block: "center" });

        handleListItemClick(mainDictionary.get(wordToOpen.dictionaryWordId))
      }
    
  }, [wordToOpen]);

  const handleCancel = () => {
    setSelectedWord(null);
    // setEditedWord(null);
    setEditing(false);
  };

  const handleSave = (editedWord) => {
    let newMap = new Map(mainDictionary)
    newMap.set(editedWord.id, editedWord)

    if (mainDictionarySetter)
      mainDictionarySetter(newMap)
    handleCancel();
  };

  const handleRemove = (wordId) => {

    let word = mainDictionary.get(wordId)
    if (word && window.confirm("Would you like to remove this word from dictionary " + JSON.stringify(word) + " ?")) {
      let newMap = new Map(mainDictionary);
      newMap.delete(wordId);
      
      if (mainDictionarySetter) {
        mainDictionarySetter(newMap);
      }
    }

  };

  return (
    <div>
      <h1>Dictionary Words</h1>
      {visibleItemsCount < words.length && (
        <p>Rendering dictionary items {Math.min(visibleItemsCount, words.length)} / {words.length}...</p>
      )}
      <Box sx={{ display: 'flex' }}>
        {/* <List className={classes.root}> */}
        <List
          ref={listRef}
          sx={{
            width: '100%',
            maxWidth: 512,
            position: 'relative',
            overflow: 'auto',
            maxHeight: window.innerHeight * 0.7
          }}
        >
          {words.slice(0, visibleItemsCount).map((wordObj) => (
            <ListItem key={wordObj.id}>
              <ListItemButton
                // button
                selected={selectedWord && selectedWord.id === wordObj.id}
                onClick={() => handleListItemClick(mainDictionary.get(wordObj.id))} 
              >
                <ListItemText primary={wordObj.word} secondary={wordObj.secondary} />
                <ListItemSecondaryAction>
                  <IconButton edge="end" onClick={() => handleRemove(wordObj.id)}>
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        {editing && 
          <WordAddForm 
          word={selectedWord} 
          isEditing={true}
          onAcceptFunc={handleSave}
          onCancelFunc={handleCancel} >
          </WordAddForm>
        }
        {/* <DictionaryWordEditor></DictionaryWordEditor> */}
      </Box>
    </div>
  );
};

export default DictionaryEditor;
